import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Consulting from './Consulting';
import Landing from './Landing';
import WhatsAppFloatButton from './components/WhatsAppFloatButton';
import ChatBot from './components/ChatBot';
import './index.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/consultoria" element={<Consulting />} />
        <Route path="*" element={<Landing />} />
      </Routes>
      <WhatsAppFloatButton />
      <ChatBot />
    </BrowserRouter>
  );
}

export default App;
